export default __webpack_public_path__ + "static/media/013-emu.0545e06a.svg";